const URL_API = 'https://pumping.epiccomunica.net/mmdwr.php';

export default class ArticleService{
  constructor(){
    console.log("init...");
  }
  async getArticulo(theparams:any){
    const urlencoded = new URLSearchParams();
    urlencoded.append("params",`ses=${theparams.ses}&flg=${theparams.flg}&idart=${theparams.idart}&startin=1&nrows=10`);
    urlencoded.append("nrows", 10);

    urlencoded.append("url","https://link2loyalty.com/ComunicaPumping/Article/getArticulo");

    let response = await fetch(URL_API,{
      method:'POST',
      headers:{'Accept':'application/json','Content-Type':'application/x-www-form-urlencoded'},
      body:urlencoded,
    });
    let responseJSON = await response.json();
    return responseJSON;
  }
}
